import img1 from '../assets/product_images/IMG-20250602-WA0030.jpg';
import img2 from '../assets/product_images/IMG-20250602-WA0025.jpg';
import img3 from '../assets/product_images/IMG-20250602-WA0018.jpg';
import img4 from '../assets/product_images/IMG-20250602-WA0015.jpg';
import img5 from '../assets/product_images/IMG-20250602-WA0012.jpg';
import img6 from '../assets/product_images/IMG-20250602-WA0011.jpg';
import img7 from '../assets/product_images/IMG-20250602-WA0009.jpg';
import img8 from '../assets/product_images/IMG-20250602-WA0007.jpg';

export const products = [
  {
    id: 1,
    name: "Elegant Silver Ring",
    description: "A timeless silver ring with intricate patterns and exceptional craftsmanship. Perfect for everyday wear or special occasions.",
    price: 89.99,
    image: img1,
    category: "Rings",
    rating: 4.8,
    reviews: 24,
    details: "This beautiful silver ring features delicate engravings and a comfortable fit. Made from 925 sterling silver with a polished finish that catches the light beautifully.",
    specifications: {
      material: "925 Sterling Silver",
      weight: "3.2g",
      size: "Adjustable",
      finish: "Polished"
    }
  },
  {
    id: 2,
    name: "Silver Pendant Necklace",
    description: "Delicate silver pendant necklace with gemstone accents. A statement piece that adds elegance to any outfit.",
    price: 129.99,
    image: img2,
    category: "Necklaces",
    rating: 4.9,
    reviews: 31,
    details: "This stunning pendant necklace showcases a beautiful silver design with carefully placed gemstone details. The chain is adjustable and the pendant is perfectly balanced for comfortable wear.",
    specifications: {
      material: "925 Sterling Silver",
      chainLength: "18-20 inches",
      pendantSize: "2.5cm x 1.8cm",
      clasp: "Lobster clasp"
    }
  },
  {
    id: 3,
    name: "Silver Bracelet",
    description: "Elegant silver bracelet for any occasion. Features a sophisticated design that complements both casual and formal attire.",
    price: 95.99,
    image: img3,
    category: "Bracelets",
    rating: 4.7,
    reviews: 18,
    details: "This sophisticated bracelet combines classic elegance with modern design. The adjustable fit ensures comfort while the polished finish adds a touch of luxury to your wrist.",
    specifications: {
      material: "925 Sterling Silver",
      width: "8mm",
      length: "7.5 inches",
      closure: "Adjustable"
    }
  },
  {
    id: 4,
    name: "Silver Earrings",
    description: "Timeless silver earrings with modern design. Lightweight and comfortable for all-day wear.",
    price: 69.99,
    image: img4,
    category: "Earrings",
    rating: 4.6,
    reviews: 22,
    details: "These elegant earrings feature a contemporary design that's both sophisticated and versatile. The lightweight construction ensures comfort during extended wear.",
    specifications: {
      material: "925 Sterling Silver",
      length: "2.5cm",
      weight: "4.1g",
      closure: "Push back"
    }
  },
  {
    id: 5,
    name: "Silver Chain Necklace",
    description: "Classic silver chain necklace with a modern twist. Perfect for layering or wearing alone.",
    price: 79.99,
    image: img5,
    category: "Necklaces",
    rating: 4.5,
    reviews: 19,
    details: "This versatile chain necklace features a contemporary link design that's perfect for everyday wear. Can be worn alone or layered with other pieces.",
    specifications: {
      material: "925 Sterling Silver",
      length: "18 inches",
      width: "2mm",
      clasp: "Lobster clasp"
    }
  },
  {
    id: 6,
    name: "Silver Bangle",
    description: "Striking silver bangle with geometric patterns. A bold statement piece that commands attention.",
    price: 149.99,
    image: img6,
    category: "Bracelets",
    rating: 4.8,
    reviews: 15,
    details: "This bold bangle features striking geometric patterns that create visual interest. The substantial weight gives it a premium feel while the polished finish ensures it catches the light beautifully.",
    specifications: {
      material: "925 Sterling Silver",
      diameter: "2.8 inches",
      width: "12mm",
      weight: "18.5g"
    }
  },
  {
    id: 7,
    name: "Silver Stud Earrings",
    description: "Minimalist silver stud earrings with a subtle sparkle. Perfect for everyday elegance.",
    price: 54.99,
    image: img7,
    category: "Earrings",
    rating: 4.7,
    reviews: 28,
    details: "These classic stud earrings feature a minimalist design that's perfect for everyday wear. The subtle sparkle adds just the right amount of glamour without being overwhelming.",
    specifications: {
      material: "925 Sterling Silver",
      diameter: "6mm",
      weight: "2.8g",
      closure: "Push back"
    }
  },
  {
    id: 8,
    name: "Silver Anklet",
    description: "Delicate silver anklet with charm details. Perfect for adding a touch of elegance to your summer look.",
    price: 64.99,
    image: img8,
    category: "Anklets",
    rating: 4.6,
    reviews: 12,
    details: "This delicate anklet features charming details that add personality to your summer style. The adjustable chain ensures a perfect fit while the lightweight design makes it comfortable for all-day wear.",
    specifications: {
      material: "925 Sterling Silver",
      length: "10 inches",
      width: "1.5mm",
      closure: "Adjustable"
    }
  }
];

export const getProductById = (id) => {
  return products.find(product => product.id === parseInt(id));
};

export const getProductsByCategory = (category) => {
  return products.filter(product => product.category === category);
};
